import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VoucherCreditServiceCodeOptionDto } from '../../services/api.service';

export interface UpdateVoucherCreditsFormValue {
  serviceCodeId: number;
  expiredDate: Date | undefined;
  shouldUpdateExpiredDate: boolean;
}

@Component({
  selector: 'cert-update-voucher-credits-modal',
  standalone: false,
  templateUrl: './update-voucher-credits-modal.component.html',
})
export class UpdateVoucherCreditsModalComponent {
  @Input() selectionCount = 0;
  @Input() serviceCodes: VoucherCreditServiceCodeOptionDto[] = [];

  serviceCodeId: number | null = null;
  shouldUpdateExpiredDate = false;
  expiredDate!: Date;

  constructor(private readonly activeModal: NgbActiveModal) {}

  confirm() {
    if (!this.serviceCodeId && !this.expiredDate) return;

    this.activeModal.close({
      serviceCodeId: this.serviceCodeId,
      expiredDate: this.shouldUpdateExpiredDate ? this.expiredDate : null,
      shouldUpdateExpiredDate: this.shouldUpdateExpiredDate,
    } as UpdateVoucherCreditsFormValue);
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
